<template>
  <main>
   <div >
    <van-tabs  v-model="activeName">
      <van-tab title="全部" name="a">
       <div>
        <van-cell title="选择日期区间" :value="date" @click="show = true" />
        <van-calendar :default-date="defaultDate" v-model="show" type="range" @confirm="onConfirm" :show-confirm="false" :allow-same-day="true" :min-date="minDate" :max-date="maxDate" />   
       </div>
      </van-tab>
      <van-tab title="未支付" name="b">
       <div>
        <van-cell title="选择日期区间" :value="date0" @click="show = true" />
        <van-calendar :default-date="defaultDate" v-model="show" type="range" @confirm="onConfirm0" :show-confirm="false" :allow-same-day="true" :min-date="minDate" :max-date="maxDate" />   
       </div>
      </van-tab>
      <van-tab title="已支付" name="c">
       <div>
        <van-cell title="选择日期区间" :value="date1" @click="show = true" />
        <van-calendar :default-date="defaultDate" v-model="show" type="range" @confirm="onConfirm1" :show-confirm="false" :allow-same-day="true" :min-date="minDate" :max-date="maxDate" />   
       </div>
      </van-tab>
      </van-tabs>
    </div>

    <div class="list" v-for="item in order" :key="item.index">
      <div class="item">
        <div>
          <h3>{{item.carNum}}</h3>
          <p>{{item.parkName}}</p>
          <i>￥{{item.amount}}元</i>
        </div>
        <div>
          <p>入场时间：{{item.inTime}}</p>
          <p>{{item.payStatusStr}}</p>
        </div>
        <div>
          <p>出场时间：{{item.outTime}}</p>
        </div>
        <div>
          <p> 缴费时间：{{item.tradeTime}}</p>
        </div>
        <div>
          <p>停车时长：{{item.duration}}</p>
        </div>
        <div>
          <p>支付方式：{{item.paySourceStr}}</p>
        </div>
      </div>
      
    </div>
    <div id="div1">
      <van-empty description="暂无订单" />
    </div>
    <tabbar current="2"></tabbar>
  </main>
</template>

<script>
    import tabbar from '../components/Tabbar.vue'
    import API from "../api/index"
    // import { Cookies } from '../util'
    import { StringUtil, Cookies } from '../util/index'

    export default {
      
        inject:['reload'],
        name: "order",
        components: {tabbar},
        data() {
            return {
                activeName: 'a',
                current: 1,
                date: '',
                date0: '',
                date1: '',
                show: false,
                order: [],
                maxDate: new Date(),
                minDate: new Date(new Date().getFullYear()-1,new Date().getMonth(),new Date().getDate()),
                defaultDate: [new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate()-1),new Date()]
            }
        },
        mounted() {
          this.query(this.defaultDate,null);
        },

        methods: {
            
            tabbtn(index) {
                this.current = index
            },

            formatDate(date) {
                return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
            },
            query(date,status){
              console.log(11111);
              const [start, end] = date;
                  this.show = false;
                  this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                  console.log(this.date);
                  
                var _this=this;
                this.$http({
                method:'post',
                data: {
                  userId:Cookies.get("userId"),
                  userType:Cookies.get("userType"),
                  payStatus: status,
                  tradeTimeStart:`${this.formatDate(start)}`,
                  tradeTimeEnd: `${this.formatDate(end)}`
                },
                url:API.order_url
                    }).then(function(resp){
                      if(resp.data.returnCode == "SUCCESS" && resp.data.data.total() >0) {
                  document.getElementById("div1").style.display="none";
                }
                        console.log(resp.data);
                        _this.order=resp.data.data.list;
                      }).catch(resp => {
                        console.log('请求失败：'+resp.status+','+resp.statusText);
                });
            },
            onConfirm(date) {
              this.query(date,null);
            },
            onConfirm0(date) {
              this.query(date,'0');
            },
            onConfirm1(date) {
              this.query(date,'1');
            },
        }
    }
</script>

<style scoped>


/deep/.van-tabs--line .van-tabs__wrap {
  height: 100px;

}

/deep/.van-tabs--line .van-tabs__wrap .van-tab__text--ellipsis {
  height: 30px;
  overflow: visible;
}

/deep/.van-cell {
  line-height: 100px;
  padding: 0 30px;
}


/deep/.van-tabs .van-calendar .van-calendar__header .van-calendar__header-title  {
  font-size: 25px;
}

/deep/.van-tabs .van-calendar .van-calendar__header .van-calendar__header-subtitle  {
  font-size: 25px;
}

/deep/.van-tabs .van-calendar .van-calendar__header .van-calendar__weekdays .van-calendar__weekday  {
  font-size: 25px;
}

/deep/.van-tabs .van-calendar .van-calendar__body .van-calendar__month .van-calendar__month-title {
  font-size: 25px;
}

/deep/.van-tabs .van-calendar .van-calendar__body .van-calendar__month .van-calendar__days .van-calendar__day   {
  font-size: 25px;
}

/deep/.van-tabs .van-calendar .van-calendar__bottom-info   {
  font-size: 15px;
}

/deep/.van-tabs .van-icon  {
  font-size: 40px;
}

  /deep/.van-empty {
    margin-top: 80px;
  }

  /deep/.van-empty .van-empty__image {
    width: 500px;
    height: 500px;
  }

  /deep/.van-empty .van-empty__description {
    font-size: 33px;
  }

  .tabbtn {
    background: #fff;
    box-shadow: 0 0 10px #ccc;
    display: flex;
    align-items: center;
    height: 80px;
    padding: 0 30px;
  }

  .tabbtn p {
    flex: 1;
    text-align: center;
    color: #999;
    font-size: 28px;
  }

  .tabbtn p.on {
    color: #0bbe72;
  }

  .select {
    margin: 20px;
  }

  .select div {
    background: #fff;
    box-shadow: 0 0 10px #ccc;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 90px;
    
  }

  .select div + div {
    margin-top: 20px;
  }

  .select div h3 {
    font-size: 26px;
  }

  .select div p {
    font-size: 26px;
    color: #999;
    padding-right: 30px;
    background: url("../assets/4.png") no-repeat right center;
    background-size: 18px;
  }

  .list {
    margin: 20px;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
    padding: 0 20px;
    border-radius: 10px;
  }

  .list .item {
    padding: 20px 0;
  }

  .list .item + .item {
    border-top: 1px solid #ccc;
  }

  .list .item div {
    display: flex;
    justify-content: space-between;
    line-height: 40px;
  }

  .list .item div:first-child {
    margin-bottom: 10px;
  }

  .list .item div {
    font-size: 28px;
  }

  .list .item div p {
    color: #999;
    font-size: 24px;
  }

  .list .item div i {
    color: #ff0000;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order.vue